import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=192ba8a4"
import script from "./PublishModal.vue?vue&type=script&lang=js"
export * from "./PublishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192ba8a4')) {
      api.createRecord('192ba8a4', component.options)
    } else {
      api.reload('192ba8a4', component.options)
    }
    module.hot.accept("./PublishModal.vue?vue&type=template&id=192ba8a4", function () {
      api.rerender('192ba8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/publish-modal/PublishModal.vue"
export default component.exports